import React, { useState, useEffect } from 'react';
import { Avatar, Button, CssBaseline, Paper, Box, Grid, Typography, FormControl, TextField } from '@material-ui/core';
import { LockOutlined } from '@material-ui/icons';
import { Alert } from '@material-ui/lab'
import useStyles from './styles';
import Copyright from '../Copyright/Copyright';
import firebase from "firebase/app";
import { auth } from '../../firebase';
import * as yup from 'yup';
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionsCreator } from '../../State/'
import { useHistory } from 'react-router-dom';
import { Field, Form, Formik } from "formik";

// types
type Inputs = {
    email: string,
    password: string,
};

const validationSchema = yup.object({
    email: yup
        .string()
        .email()
        .required('Enter a Valid Email'),
    password: yup
        .string()
        .required('Password Required'),
});

const SignIn = () => {
    const classes = useStyles();
    const [loading, setLoading] = useState(true);
    const [notFound, setNotFound] = useState(false);
    const dispatch = useDispatch();
    const { changeUser } = bindActionCreators(actionsCreator, dispatch);
    const history = useHistory();

    const formik = {
        // enableReinitialize: true,
        initialValues: {
            email: "",
            password: ""
        },
        validationSchema: validationSchema,
        onSubmit: async (values: Inputs) => {
            const {email, password} = values;
            setLoading(true);
            // console.log({ email, password });

            auth.signInWithEmailAndPassword(email, password)
                .then(() => {
                    setLoading(false);
                    // history.push('/chats');
                })
                .catch(() => {
                    setLoading(false);
                    setNotFound(true);
                });
        },
    };

    useEffect(() => {
        auth.onAuthStateChanged(user => {

            
            if (user) {
                // console.log("from hereeee, yes there are a user: ", {user});
                changeUser(user);
                history.push('/chats');
                return;
            }
            setLoading(false);
        })

    }, [loading, history]);


    const handleGoogleSingIn = (e: React.MouseEvent<HTMLButtonElement>) => {
        setLoading(true)
        auth.signInWithRedirect(new firebase.auth.GoogleAuthProvider());
    }

    if (loading) {
        return <h5>Loading ...</h5>
    }

    return (
        <Grid container component="main" className={classes.root}>
            <CssBaseline />
            <Grid item xs={false} sm={4} md={7} className={classes.image} />

            <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
                <div className={classes.paper}>
                    <Avatar className={classes.avatar}>
                        <LockOutlined />
                    </Avatar>

                    <Typography component='h1' variant='h5'>
                        Sign in
                    </Typography>

                    {
                        notFound && (
                            <Alert severity="error" style={{ marginBottom: '10px' }}>
                                Account Not Found
                            </Alert>
                        )
                    }

                    <Alert severity="info">
                        Use email: <span className={classes.alertSpan}>first.last@example.xy</span> / password: <span className={classes.alertSpan}>SecretPassword</span>
                    </Alert>
                    <Alert severity="info" style={{marginTop: '5px'}}>
                        Or email: <span className={classes.alertSpan}>name.last@example.com</span> / password: <span className={classes.alertSpan}>SecretPassword</span>
                    </Alert>

                    <Formik
                        {
                        ...formik
                        }
                    >
                        {({ values, isValid }) => (
                            <Form
                                className="myForm"
                            >
                                <Paper elevation={3} className={classes.paper} style={{ padding: '20px' }}>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12}>
                                            <FormControl fullWidth variant="outlined">
                                                {/* <InputLabel id="email-label">Email</InputLabel> */}
                                                <Field
                                                    as={TextField}
                                                    name="email"
                                                    label="Email"
                                                    type='email'
                                                    variant="outlined"
                                                    value={values.email}
                                                    autoComplete="email"
                                                    // labelId="email-label"
                                                    // InputProps={{ inputProps: { min: 1 } }}
                                                    required
                                                />
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <FormControl fullWidth variant="outlined">
                                                {/* <InputLabel id="password-label">Password</InputLabel> */}
                                                <Field
                                                    as={TextField}
                                                    name="password"
                                                    label="Password"
                                                    type='password'
                                                    variant="outlined"
                                                    value={values.password}
                                                    autoComplete="current-password"
                                                    // labelId="password-label"
                                                    // InputProps={{ inputProps: { min: 1 } }}
                                                    required
                                                />
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Button type='submit' variant="contained" color='primary' fullWidth disabled={!isValid}>
                                                SignIn
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Form>
                        )
                        }
                    </Formik >

                    <Typography className={classes.or} variant="body2" color="textSecondary" align="center">
                        <span className={classes.orSpan}>or</span>
                    </Typography>

                    <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.google}
                        onClick={handleGoogleSingIn}
                    >
                        Sign in with Google
                    </Button>

                    <Box mt={5}>
                        <Copyright />
                    </Box>
                </div>
            </Grid>
        </Grid>
    )
}

export default SignIn
